import Vue from "vue";
import Router from "vue-router";
import Index from "@/components/Index/index";

// 二级搜索
import Search from "@/components/Search/index";
// 组织结构
import Organization from "@/components/Organization/index";
import centerIntro from "@/components/Organization/Children/centerIntro";
import centerLeader from "@/components/Organization/Children/centerLeader";
import duty from "@/components/Organization/Children/duty";
import organMap from "@/components/Organization/Children/organMap";
// 科研与国际合作
import Cooperation from "@/components/Cooperation/index";
import CooperMajor from "@/components/Cooperation/Children/major";
import CooperDetail from "@/components/Cooperation/Children/detail";
import interCooper from "@/components/Cooperation/Children/interCooper";
import manageMent from "@/components/Cooperation/Children/manageMent";
// 人事
import Personnel from "@/components/Personnel/index";
import education from "@/components/Personnel/Children/education";
import recruitment from "@/components/Personnel/Children/recruitment";
import articleDetails from "@/components/Personnel/Children/detail";
// 期刊
import Journal from "@/components/Journal/index";
import JournalList from "@/components/Journal/list";
import JournalDetail from "@/components/Journal/detail";
//业务工作
import Business from "@/components/BusinessWork/index";
import BusinessIntro from "@/components/BusinessWork/Children/introduction";
import BusinessDetail from "@/components/businessWork/Children/detail";

//公告
import announce from "@/components/Announce/index";
import announceList from "@/components/Announce/list";
import announceDetail from "@/components/Announce/detail";
// 部门新闻和中心xinwen
import News from "@/components/News/index";
import NewsList from "@/components/News/list";
import NewsDetail from "@/components/News/detail"
// 党风建设
import comParty from "@/components/ComParty/index";
import comPartyList from "@/components/ComParty/list";
import comPartyDetail from "@/components/ComParty/detail";
import contractUs from "@/components/conUs/contract";
import stateMent from "@/components/conUs/statement";
import multipleinfo from "@/components/conUs/multipleinfo";

import supervise from "@/components/conUs/supervise";
import partyBuilding from "@/components/PartyBuilding/partyBuilding";
import partyDetail from "@/components/PartyDetail/partyDetail";

import linkPage from "@/components/LinkPage/index";
Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "Index",
      component: Index,
      meta: {
        navFlag: true//是否显示顶部的
      }
    },
    {
      path: "/partyBuilding",
      name: "partyBuilding",
      component: partyBuilding,
      meta: {
        name: "contractUs",
        showFlag: "",
        firstTitle: "党建专题",
        secondTitle: "",
        searchFlag:false
      }
    },
    {
      path: "/partyDetail",
      name: "partyDetail",
      component: partyDetail,
      meta: {
        name: "contractUs",
        showFlag: "",
        firstTitle: "党建专题",
        secondTitle: "",
        searchFlag:false
      }
    },
    {
      path: "/search",
      name: "Search",
      component: Search,
      meta: {
        navFlag: true
      }
    },
    {
      path: "/org",
      // name: 'Organization',
      component: Organization,
      children: [
        {
          path: "",
          redirect: "intro",
        },
        {
          path: "intro",
          name: "centerIntro",
          component: centerIntro,
          meta: {
            name: "centerIntro",
            showFlag: "1",
            firstTitle: "中心概况",
            secondTitle: "中心简介",
            searchFlag:false
          }
        },
        {
          path: "map",
          name: "centerMap",
          component: organMap,
          meta: {
            name: "centerMap",
            showFlag: "1",
            firstTitle: "中心概况",
            secondTitle: "组织架构图",
            searchFlag:false
          }
        },
        {
          path: "leader",
          name: "centerLeader",
          component: centerLeader,
          meta: {
            name: "centerLeader",
            showFlag: "1",
            firstTitle: "中心概况",
            secondTitle: "中心领导",
            searchFlag:false
          }
        },
        {
          path: "duty",
          name: "centerDuty",
          component: duty,
          meta: {
            name: "centerDuty",
            showFlag: "1",
            firstTitle: "中心概况",
            secondTitle: "部门职责",
            searchFlag:false
          }
        }
      ]
    },
    {
      path: "/cooperation",
      component: Cooperation,
      children: [
        {
          path: "",
          redirect: "major"
        },
        {
          path: "major",
          name: "CooperMajor",
          component: CooperMajor,
          meta: {
            name: "CooperMajor",
            showFlag: "6",
            firstTitle: "科研与国际合作",
            secondTitle: "重大专项",
            searchFlag:true
          }
        },
        {
          path: "detail",
          name: "CooperDetail",
          component: CooperDetail,
          meta: {
            name: "CooperDetail",
            showFlag: "6",
            firstTitle: "科研与国际合作",
            secondTitle: "",
            searchFlag:false
          }
        },
        {
          path: "inter",
          name: "interCooper",
          component: interCooper,
          meta: {
            name: "interCooper",
            showFlag: "6",
            firstTitle: "科研与国际合作",
            secondTitle: "国际合作",
            searchFlag:true
          }
        },
        {
          path: "manage",
          name: "manageMent",
          component: manageMent,
          meta: {
            name: "manageMent",
            showFlag: "6",
            firstTitle: "科研与国际合作",
            secondTitle: "科研项目管理",
            searchFlag:true
          }
        }
      ]
    },
    {
      path: "/person",
      component: Personnel,
      children: [
        {
          path: "",
          redirect: "education"
        },
        {
          path: "education",
          name: "education",
          component: education,
          meta: {
            name: "education",
            showFlag: "7",
            firstTitle: "人事",
            secondTitle: "教育培训",
            searchFlag:true
          }
        },
        {
          path: "recruitment",
          name: "recruitment",
          component: recruitment,
          meta: {
            name: "recruitment",
            showFlag: "7",
            firstTitle: "人事",
            secondTitle: "人才招聘",
            searchFlag:true
          }
        },
        {
          path: "articleDetails",
          name: "articleDetails",
          component: articleDetails,
          meta: {
            name: "education",
            showFlag: "7",
            firstTitle: "人事",
            searchFlag:false
          }
        }
      ]
    },
    {
      path: "/journal",
      component: Journal,
      children: [
        {
          path: "",
          redirect: "list"
        },
        {
          path: "list",
          name: "JournalList",
          component: JournalList,
          meta: {
            name: "JournalList",
            showFlag: "8",
            firstTitle: "期刊",
            secondTitle: "全部",
            searchFlag:false
          }
        },
        {
          path: "detail",
          name: "JournalDetail",
          component: JournalDetail,
          meta: {
            name: "JournalDetail",
            showFlag: "8",
            firstTitle: "期刊",
            secondTitle: "",
            searchFlag:false
          }
        }
      ]
    },
    {
      path: "/businesss",
      component: Business,
      children: [
        {
          path: "",
          redirect: "intro"
        },
        {
          path: "intro",
          name: "BusinessIntro",
          component: BusinessIntro,
          meta: {
            name: "BusinessIntro",
            showFlag: "3",
            firstTitle: "业务工作",
            secondTitle: "",
            searchFlag:true
          }
        },
        {
          path: "detail",
          name: "BusinessDetail",
          component: BusinessDetail,
          meta: {
            name: "BusinessDetail",
            showFlag: "3",
            firstTitle: "业务工作",
            secondTitle: "",
            searchFlag:false
          }
        }
      ]
    },
    {
      path: "/news",
      component: News,
      children: [
        {
          path: "",
          redirect: "list"
        },
        {
          path: "list",
          name: "NewsList",
          component: NewsList,
          meta: {
            name: "NewsList",
            showFlag: "",
            firstTitle: "新闻",
            secondTitle: "",
            searchFlag:true
          }
        },
        {
          path: "detail",
          name: "NewsDetail",
          component: NewsDetail,
          meta: {
            name: "NewsDetail",
            showFlag: "",
            firstTitle: "新闻",
            secondTitle: "",
            searchFlag:false
          }
        }
      ]
    },
    {
      path: "/com-party",
      component: comParty,
      children: [
        {
          path: "",
          redirect: "list"
        },
        {
          path: "list",
          name: "comPartyList",
          component: comPartyList,
          meta: {
            name: "comPartyList",
            showFlag: "2",
            firstTitle: "党建",
            secondTitle: "",
            searchFlag:true
          }
        },
        {
          path: "detail",
          name: "comPartyDetail",
          component: comPartyDetail,
          meta: {
            name: "comPartyDetail",
            showFlag: "2",
            firstTitle: "党建",
            secondTitle: "",
            searchFlag:false
          }
        }
      ]
    },
    {
      path: "/announce",
      component: announce,
      children: [
        {
          path: "",
          redirect: "list"
        },
        {
          path: "list",
          name: "announceList",
          component: announceList,
          meta: {
            name: "announceList",
            showFlag: "",
            firstTitle: "公告",
            secondTitle: "",
            searchFlag:true
          }
        },
        {
          path: "detail",
          name: "announceDetail",
          component: announceDetail,
          meta: {
            name: "announceDetail",
            showFlag: "",
            firstTitle: "公告",
            secondTitle: "",
            searchFlag:false
          }
        }
      ]
    },
    {
      path: "/conus",
      component: contractUs,
      name: "contractUs",
      meta: {
        name: "contractUs",
        showFlag: "",
        firstTitle: "联系我们",
        secondTitle: "",
        searchFlag:false
      }
    },
    {
      path: "/statement",
      component: stateMent,
      name: "statement",
      meta: {
        name: "statement",
        showFlag: "",
        firstTitle: "版权声明",
        secondTitle: "",
        searchFlag:false
      }
    },
    // 多页面
    {
      path: "/multipleinfo",
      component: multipleinfo,
      name: "multipleinfo",
      meta: {
        name: "multipleinfo",
        showFlag: "",
        firstTitle: "",
        secondTitle: "",
        searchFlag:false
      }
    },
    {
      path: "/supervise",
      component: supervise,
      name: "supervise"
    },
    {
      path: "/linkPage",
      component: linkPage,
      name: "linkPage",
      meta:{
        showFlag:'',
        firstTitle: "团体标准管理系统",
        secondTitle: "",
        searchFlag:false
      }
    },
    {
      path: "*",
      redirect: "/"
    },
  ]
});
/**
 * 判断是否为移动设备，是，则跳转到移动端的路径
 */
router.beforeEach((to, from, next) => {
  if (!/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    window.location.href = 'http://www.ncosm.org.cn/#/'
    return
  }
  next()
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js